// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1KG8_","question":"Question_question__2mFWx","description":"Question_description__2eNo5"};